import React from "react";
import { concatClassnames } from "shared/utils/concatClassnames";

export const Delimiter = ({ className }: { className?: string }) => {
  return (
    <hr
      className={concatClassnames(`gg-w-full gg-bg-dark-blue-100`, className)}
    />
  );
};
